import { axios } from 'apis';

const ENDPOINT = 'BonusCalculation';

export const BonusCalculationService = {
	processDailyBonusChanges: async () => {
		const response = await axios.get(`${ENDPOINT}/ProcessDailyBonusChanges`);
		return (await response.data) as boolean;
	},
	processWeeklyBonusChanges: async (week: number, year: number) => {
		const response = await axios.get(`${ENDPOINT}/ProcessWeeklyBonusChanges?weekNumber=${week}&year=${year}`);
		return await response.data;
	},
	processMonthlyBonusChanges: async (month: number, year: number) => {
		const response = await axios.get(`${ENDPOINT}/ProcessMonthlyBonusChanges?month=${month}&year=${year}`);
		return await response.data;
	},
};